import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface EmojiCategory {
  slug: string; // p.ej. "smileys-emotion"
  subCategories: string[];
}

export interface EmojiItem {
  slug: string;
  character: string; // ← el emoji que necesitas
  unicodeName: string;
  codePoint: string;
  group: string;
  subGroup: string;
}

@Injectable({ providedIn: 'root' })
export class EmojiApiService {
  private readonly base = 'https://emoji-api.com';
  private cacheCategories$?: Observable<EmojiCategory[]>;
  private cacheByCategory = new Map<string, Observable<EmojiItem[]>>();

  constructor(private http: HttpClient) {}

  getCategories(): Observable<EmojiCategory[]> {
    if (!this.cacheCategories$) {
      this.cacheCategories$ = this.http
        .get<EmojiCategory[]>(`${this.base}/categories`, {
          params: { access_key: environment.emojiApiKey },
        })
        .pipe(shareReplay(1));
    }
    return this.cacheCategories$;
  }

  getEmojisByCategory(slug: string): Observable<EmojiItem[]> {
    if (!this.cacheByCategory.has(slug)) {
      const req$ = this.http
        .get<EmojiItem[]>(`${this.base}/categories/${slug}`, {
          params: { access_key: environment.emojiApiKey },
        })
        .pipe(
          // Aseguramos que venga ordenado y solo el carácter
          map((arr) =>
            arr.filter((e) => !!e.character && e.character.trim() !== '')
          ),
          shareReplay(1)
        );
      this.cacheByCategory.set(slug, req$);
    }
    return this.cacheByCategory.get(slug)!;
  }

  // Método adicional para obtener todos los emojis sin filtro de categoría
  getAllEmojis(): Observable<EmojiItem[]> {
    return this.http
      .get<EmojiItem[]>(`${this.base}/emojis`, {
        params: { access_key: environment.emojiApiKey },
      })
      .pipe(
        map((arr) =>
          arr.filter((e) => !!e.character && e.character.trim() !== '')
        ),
        shareReplay(1)
      );
  }
}
